export default {
    QUOTES_AND_APPLICATIONS: "quotes_&_applications",
    PASA_CAMPAIGN: "pasa_campaign",
    BONUS_CAMPAIGN: "upselling_campaign",
    OPPORTUNITY_CAMPAIGN: "opportunity_campaign"
  };